import {
	confirmTableModalDataSuccess,
	getTableModalDataSuccess,
	getTableModalPaginationSuccess,
	selectAllTableModalDataSuccess,
	selectTableModalDataSuccess
} from 'actions/TableModalActions'
import {
	confirmTableModalData,
	getTableModalData,
	getTableModalPagination,
	selectAllTableModalData,
	selectTableModalData
} from 'api/TableModalApi'
import { TableModalActions } from 'constants/ActionsTypesTs'
import {
	IConfirmTableModalDataSaga,
	IGetTableModalDataSaga,
	IGetTableModalPaginationSaga,
	ISelectAllTableModalDataSaga,
	ISelectTableModalDataSaga
} from 'models/TableModal'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'

function* getTableModalDataRequest({ payload }: IGetTableModalDataSaga): any {
	try {
		const values: any = yield call(getTableModalData, payload)
		yield put(getTableModalDataSuccess(values))
	} catch (error) {}
}

function* getTableModalPaginationRequest({
	payload
}: IGetTableModalPaginationSaga): any {
	try {
		const values: any = yield call(getTableModalPagination, payload)
		yield put(getTableModalPaginationSuccess(values))
	} catch (error) {}
}

function* selectTableModalDataRequest({
	payload
}: ISelectTableModalDataSaga): any {
	try {
		const values: any = yield call(selectTableModalData, payload)
		yield put(selectTableModalDataSuccess(values))
	} catch (error) {}
}

function* selectAllTableModalDataRequest({
	payload
}: ISelectAllTableModalDataSaga): any {
	try {
		const values: any = yield call(selectAllTableModalData, payload)
		yield put(selectAllTableModalDataSuccess(values))
	} catch (error) {}
}

function* confirmTableModalDataRequest({
	payload
}: IConfirmTableModalDataSaga): any {
	try {
		const values: any = yield call(confirmTableModalData, payload)
		yield put(confirmTableModalDataSuccess(values))
	} catch (error) {}
}

export function* getTableModalDataSaga() {
	yield takeLatest(
		TableModalActions.GET_TABLE_MODAL_DATA,
		getTableModalDataRequest
	)
}

export function* getTableModalPaginationSaga() {
	yield takeLatest(
		TableModalActions.GET_TABLE_MODAL_PAGINATION,
		getTableModalPaginationRequest
	)
}

export function* selectTableModalDataSaga() {
	yield takeLatest(
		TableModalActions.SELECT_TABLE_MODAL_DATA,
		selectTableModalDataRequest
	)
}

export function* selectAllTableModalDataSaga() {
	yield takeLatest(
		TableModalActions.SELECT_ALL_TABLE_MODAL_DATA,
		selectAllTableModalDataRequest
	)
}

export function* confirmTableModalDataSaga() {
	yield takeLatest(
		TableModalActions.CONFIRM_TABLE_MODAL_DATA,
		confirmTableModalDataRequest
	)
}

export default function* rootSaga() {
	yield all([
		fork(getTableModalDataSaga),
		fork(getTableModalPaginationSaga),
		fork(selectTableModalDataSaga),
		fork(selectAllTableModalDataSaga),
		fork(confirmTableModalDataSaga)
	])
}
